import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-x py-32 md:py-48 text-center" data-testid="not-found">
      <div className="overline">404</div>
      <h1 className="mt-6 font-display font-light tracking-tight text-5xl md:text-7xl">
        Page not found.
      </h1>
      <p className="mt-6 text-zinc-400 max-w-md mx-auto">
        The page you&rsquo;re looking for has moved or never existed. Let&rsquo;s
        get you back to ground.
      </p>
      <Link to="/" className="btn-gold mt-10 inline-flex" data-testid="not-found-home">
        Back to home
      </Link>
    </section>
  );
}
